var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('el-pagination',{attrs:{"current-page":_vm.page.currentPage,"page-sizes":[20, 40, 60],"page-size":_vm.page.currtNum,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.page.getCurrtNum},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }